<template>
    <div class="form-group">
        <label class="label-rangeval" :for="formName">{{text}}
            <small v-if="text2"> {{text2}}</small>
        </label>
        <div class="rangeval--outer">
            <input type="range" v-model="rangeValue" :min="min" :max="max" step="1" data-orientation="vertical" class="rangeval" :id="id">
            <input type="text" class="rangevalNumber" @wheel.prevent="wheelIt($event, rangeValue)" maxlength="4" v-model="rangeValue"   v-on="listeners" ref="editable" />
            <!-- v-on="listeners" -->
            <!-- v-on:change="onChangeValue" -->
        </div>
    </div>
</template>

<script>
export default {
    name: "FormSlider",
    props: {
        id: String,
        text: String,
        text2: String,
        formName: String,
        initialValue: {
            type: [String, Number, null],
        },
        max: {
            defaul: 1000,
        },
        min: {
            type: Number,
            default: 10
        }

    },
    watch: {
        rangeValue: {
            handler: function(newValue) {
                //this.formChanged();
                this.$emit('input', newValue);
            },
            deep: true,
        }
    },
    mounted() {
       console.log('Mounted');
       this.rangeValue = this.initialValue;
       //this.$refs.editable.innerText = this.value;
    },
    computed: {
        listeners() {
            /* return { ...this.$listeners, input: this.onInput }; */
            return { ...this.$listeners, input: this.onInput };
        },
    },
    methods: {
        /*
        formChanged() {
            clearTimeout(this.formTimeout);
            var thisComponent = this;
            this.formTimeout = setTimeout(function() {
                thisComponent.formBoxPreviewSubmit();
            }, 100);
        },
        formBoxPreviewSubmit() {
            console.log('formBoxPreviewSubmit rangevalue: ', this.rangeValue);

        }
        */
        wheelIt(event, number){
            event.deltaY < 0 ? number++ : number--;
            if(number > 1500) {
                number = 1500;
                this.rangeValue = number;
            } 
            else if(number < 0) {
                number = 1;
                this.rangeValue = number;
            } 
            this.rangeValue = number;
        },

        onChangeValue(e) {
            //console.log(e);
            let number = this.rangeValue;
            console.log(number);
            if(number > 1500) {
                number = 1500;
                e.target.innerText = number;
                this.rangeValue = number;
            } 
        },
        onInput(e) {
            let number = this.rangeValue;
            console.log('input:', number);
            
            let reg = /\D/g;
            let match = number.match(reg);

            if(number > 1500) {
                number = 1500;
                this.rangeValue = number;
            } 
            else if(number < 0) {
                number = 1;
                this.rangeValue = number;
            } 
            else if(match || isNaN(number) && number != ''){
                number = 1;
                this.rangeValue = number;

            }
        },
    },
    data() {
        return {
            rangeValue: 0,
            formTimeout: false,
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
input, label, button {
    font-family: 'Lato', Arial, sans-serif;
    color:#555555;
}
input {
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.rangeval--outer {
    display: grid;
    grid-template-columns: 80% 70px;
    //grid-template-rows: ;
    gap: 3px 1px;
    grid-template-areas: ". .";
    @media only screen and (min-width: 320px) and (max-width: 800px) {
        grid-template-columns: 75% 70px;
    }
}
label {
    text-transform: uppercase;
}
label > small {
    font-weight: 400;
    text-transform: none;
}
.rangevalNumber {
    right: 0px;
    background-color: #fbfbfb;
    border: 1px solid #aaa;
}
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
